import { createStore } from 'vuex'
import data from './data'

const store = createStore({
  modules: {
    data,
  },
})

export default store